import axios from 'axios'
import { ElMessageBox } from 'element-plus'
import { getToken, removeToken } from '@/utils/auth' // get token from cookie


// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_HOST_GO, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 500000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (getToken()) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['token'] = getToken()
    }
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    const statusCode = response.status;  // 获取 HTTP 状态码
    if(!res){
      return statusCode
    }
    if(!res.code){
      return res
    }
    // if the custom code is not 200, it is judged as an error.
    if (res.code !== 200) {
      // 4001: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 4007 || res.code === 4009) {
        // to re-login
        ElMessageBox.alert(res.msg, '提示', {
          confirmButtonText: '确认',
          callback: () => {
            // 清除浏览器token缓存
            removeToken()
            location.reload()
          },
        })
        return res
      }
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export default service
